import { render, staticRenderFns } from "./LazyImage.vue?vue&type=template&id=8309fd0e&"
import script from "./LazyImage.vue?vue&type=script&lang=js&"
export * from "./LazyImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports